export default __webpack_public_path__ + "static/media/talksCardBackAlt.3919b921.svg";